import { render, staticRenderFns } from "./TestingToolsIntro.vue?vue&type=template&id=49cbf18d&scoped=true"
import script from "./TestingToolsIntro.vue?vue&type=script&lang=js"
export * from "./TestingToolsIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cbf18d",
  null
  
)

export default component.exports